import axios from 'axios';
import * as config from '../../Config/api.js';
import prepareFinalPartnerFormData from '../../Helpers/buildPartnerFormData.js';

/* -------------------------------------------------------------------- */
/*  Helpers                                                             */
/* -------------------------------------------------------------------- */

const getUserToken = () => {
  try {
    const raw = localStorage.getItem('@estacaodoolho/userData');
    if (!raw) return null;
   
    return raw;
   // const parsed = JSON.parse(raw);
   // return parsed?.userToken || null;

  } catch (e) {
    return null;
  }
};


export const updateStepData = (stepIndex, data) => ({
    type: 'UPDATE_STEP_DATA',
    payload: { stepIndex, data }
  });

export const setLead  = (value) => { 
  return { 
    type: 'SET_CURRENT_LEAD',
    payload: value 
  }
};

export const resetPartnerStepData = () => ({
    type: 'RESET_PARTNER_STEP_DATA'
  });

  // Função para buscar serviços
  export const retrieveCompanyServices = (props = {}) => {
    return (dispatch) => {
      const preparedData = {
        type: 'service'
      };
  
      axios({
        url: `${config.API_URL}/system/retrieveCompanyServices`,
        method: 'POST',
        data: preparedData,
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          const result = response.data;
          //console.log('[retrieveCompanyServices] Resultado:', result); // Debug
  
          if (!result || result.status !== true) {
            if (props.setError) {
              props.setError(result?.message || 'Erro ao consultar serviços.');
            }
            return;
          }
  
          dispatch({ type: 'SET_SERVICES_LIST', payload: result.data });
  
          if (props.setSuccess) {
            props.setSuccess(result.data);
          }
  
        })
        .catch((error) => {
          console.error('Erro ao buscar serviços:', error);
          if (props.setError) {
            props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
          }
        });
    };
  };
  
// Função para buscar descontos em opticas
  export const retrieveCompanyDiscounts = (props = {}) => {
    return (dispatch) => {
      const preparedData = {
        type: 'discount'
      };
  
      axios({
        url: `${config.API_URL}/system/retrieveCompanyServices`,
        method: 'POST',
        data: preparedData,
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          const result = response.data;
         // console.log('[retrieveCompanyDiscounts] Resultado:', result); // Debug
  
          if (!result || result.status !== true) {
            if (props.setError) {
              props.setError(result?.message || 'Erro ao consultar descontos.');
            }
            return;
          }
  
          dispatch({ type: 'SET_DISCOUNTS_LIST', payload: result.data });
  
          if (props.setSuccess) {
            props.setSuccess(result.data);
          }
  
        })
        .catch((error) => {
          console.error('Erro ao buscar serviços:', error);
          if (props.setError) {
            props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
          }
        });
    };
  };
  
  // Função para buscar subespecialidades
  export const retrieveCompanySpecialities = (props = {}) => {
    return (dispatch) => {
      const preparedData = {
        parent: 1
      };
  
      axios({
        url: `${config.API_URL}/system/retrieveCompanySpecialities`,
        method: 'POST',
        data: preparedData,
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          const result = response.data;
          console.log('[retrieveCompanySpecialities] Resultado:', result); // Debug
  
          if (!result || result.status !== true) {
            if (props.setError) {
              props.setError(result?.message || 'Erro ao consultar subespecialidades.');
            }
            return;
          }
  
          dispatch({ type: 'SET_SPECIALITIES_LIST', payload: result.data });
  
          if (props.setSuccess) {
            props.setSuccess(result.data);
          }
  
        })
        .catch((error) => {
          console.error('Erro ao buscar subespecialidades:', error);
          if (props.setError) {
            props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
          }
        });
    };
  };

  
export const registerPartner = () => {

  return async (dispatch, getState) => {
    const state = getState();
    const stepDataAll = state.partnerReducer.stepData;

    try {

      const formData = prepareFinalPartnerFormData(stepDataAll);

      const response = await axios({
        method: 'POST',
        url: `${config.API_URL}/company/startRegister`,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json'
        }
      });

      const result = response.data;
      console.log('[enviarCadastroFinal] response:', result);

      // 🧠 Trata diferentes tipos de resposta
      if (result?.documentAlreadyUsed) {
        return {
          success: false,
          errorMessage: 'Já existe uma empresa com o CNPJ informado.'
        };
      }

      if (result?.contactAlreadyUsed) {
        return {
          success: false,
          errorMessage: result.emailAlreadyUsed && result.phoneAlreadyUsed
            ? 'Email e telefone já estão em uso.'
            : result.emailAlreadyUsed
              ? 'Email já está em uso.'
              : 'Telefone já está em uso.'
        };
      }

      if (!result?.success) {
        return {
          success: false,
          errorMessage: result?.errorMessage || 'Erro inesperado ao enviar cadastro.'
        };
      }

      // 🔐 Sucesso com token
      if (result?.token) {
        return {
          success: true,
          token: result.token,
        };
      }

      return {
        success: true
      };

    } catch (error) {
      console.error('[enviarCadastroFinal] erro:', error);
      return {
        success: false,
        errorMessage: error?.response?.data?.errorMessage || 'Falha na conexão ou erro inesperado.'
      };
    }
  };
};
  

export const retrieveCompanyCreditcards = (props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/retrieveCreditcards`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      }
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          if (props.setSuccess) {
            props.setSuccess(result.data); // Lista de cartões
          }
        } else {
          if (props.setError) {
            props.setError(result.message || 'Erro ao buscar cartões de crédito.');
          }
        }
      })
      .catch((error) => {
        console.error('Erro ao buscar cartões de crédito:', error);
        if (props.setError) {
          props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};

export const createCompanyCreditcard = (data, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/createCreditcard`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data: data
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          if (props.setSuccess) props.setSuccess(result);
        } else {
          if (props.setError) props.setError(result.message || 'Erro ao adicionar cartão.');
        }
      })
      .catch((error) => {
        console.error('Erro ao criar cartão:', error);
        if (props.setError) {
          props.setError('Erro inesperado ao adicionar cartão. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};

export const updateCompanyCreditcard = (data, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/updateCreditcard`,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data: data
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          if (props.setSuccess) props.setSuccess(result);
        } else {
          if (props.setError) props.setError(result.message || 'Erro ao atualizar cartão.');
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar cartão:', error);
        if (props.setError) {
          props.setError('Erro inesperado ao atualizar cartão. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};


export const deleteCompanyCreditcard = (id, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/deleteCreditcard`,
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data: { creditcardId:id }
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          if (props.setSuccess) props.setSuccess();
        } else {
          if (props.setError) props.setError(result.message || 'Erro ao excluir cartão.');
        }
      })
      .catch((error) => {
        console.error('Erro ao excluir cartão:', error);
        if (props.setError) {
          props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};

export const retrieveCompanyComprobationDocuments = (props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/retrieveDocuments`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      }
    })
      .then((response) => {
        const result = response.data;

        if (result.success && props.setSuccess) {
          props.setSuccess(result.data);
        } else if (props.setError) {
          props.setError(result.message || 'Erro ao carregar documentos.');
        }
      })
      .catch((error) => {
        console.error('Erro ao recuperar documentos:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão.');
      });
  };
};

export const createCompanyComprobationDocument = (formData, onSuccess, onError) => {
  return dispatch => {

    axios({
      url: `${config.API_URL}/api/v1/company/createDocument`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      }
    })
      .then(response => {
        if (response.data.success) {
          if (onSuccess) onSuccess(response.data);
        } else {
          if (onError) onError(response.data.message || 'Erro ao enviar documento.');
        }
      })
      .catch((error) => {
        console.error('Erro ao criar documento:', error);

        const msg = error?.response?.data?.errorMessage || error?.response?.data?.message || 'Erro inesperado. Verifique sua conexão ou tente novamente.';

        if (onError) onError(msg);
      });
  };
};

export const deleteCompanyComprobationDocument = (type, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/deleteDocument`,
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data: { documentType:type }
    })
      .then((response) => {
        if (response.data.success) {
          if (props.setSuccess) props.setSuccess();
        } else if (props.setError) {
          props.setError(response.data.message || 'Erro ao excluir documento.');
        }
      })
      .catch((error) => {
        console.error('Erro ao excluir documento:', error);

        const msg = error?.response?.data?.errorMessage || error?.response?.data?.message || 'Erro inesperado. Verifique sua conexão ou tente novamente.';

        if (props.setError) props.setError(msg);
      });
  };
};

export const deleteCompanyComprobationDocumentFile = (id, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/deleteDocumentFile`,
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data: { documentId:id }
    })
      .then((response) => {
        if (response.data.success) {
          if (props.setSuccess) props.setSuccess();
        } else if (props.setError) {
          props.setError(response.data.message || 'Erro ao excluir arquivo.');
        }
      })
      .catch((error) => {
        console.error('Erro ao excluir arquivo do documento:', error);

        const msg = error?.response?.data?.errorMessage || error?.response?.data?.message || 'Erro inesperado. Verifique sua conexão ou tente novamente.';

        if (props.setError) props.setError(msg);
      });
  };
};

export const retrieveCompanyDashboard = (data, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/dashboard`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data
    })
      .then(response => {
        if (response.data?.success && props.setSuccess) {
          props.setSuccess(response.data.data);
        } else if (props.setError) {
          props.setError(response.data?.errorMessage || 'Erro ao carregar dashboard.');
        }
      })
      .catch(error => {
        console.error('Erro ao carregar dashboard:', error);
        const msg = error?.response?.data?.errorMessage || error?.response?.data?.message || 'Erro inesperado. Verifique sua conexão ou tente novamente.';
        if (props.setError) props.setError(msg);
      });
  };
};

export const retrieveCompanyPersonData = (props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/retrieveCompanyPersonData`,
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      }
    })
      .then((response) => {
        if (response.data.success) {
          if (props.setData) props.setData(response.data.data);
        } else if (props.setError) {
          props.setError(response.data.message || 'Erro ao buscar dados do usuário.');
        }
      })
      .catch((error) => {
        console.error('Erro ao buscar dados do usuário:', error);
        const msg = error?.response?.data?.errorMessage || 'Erro inesperado.';
        if (props.setError) props.setError(msg);
      });
  };
};

export const updateCompanyPersonUserPassword = (payload, props = {}) => {
  return dispatch => {
    axios({
      url: `${config.API_URL}/api/v1/company/updateCompanyPersonUserPassword`,
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      },
      data: payload
    })
      .then((response) => {
        if (response.data.success && response.data.validPassword !== false) {
          if (props.setSuccess) props.setSuccess();
        } else if (response.data.validPassword === false && props.setError) {
          props.setError('Senha atual incorreta.');
        } else if (props.setError) {
          props.setError(response.data.message || 'Erro ao atualizar a senha.');
        }
      })
      .catch((error) => {
        console.error('Erro ao atualizar a senha:', error);
        const msg = error?.response?.data?.errorMessage || 'Erro inesperado.';
        if (props.setError) props.setError(msg);
      });
  };
};


// Flag simples para alternar fake/real rapidamente
const USE_FAKE_LEADS = false;

// -----------------------------
// Helpers FAKE
// -----------------------------
const buildFakeLead = (id) => {
  const now = new Date();
  const createdAt = new Date(now.getTime() - (id * 3600 * 1000));

  const isService = id % 2 === 0;
  const type = isService ? 'service' : 'discount';

  const status = id % 3; // 0/1/2
  const targetType = id % 2 === 0 ? 'own' : 'thirdparty';

  return {
    leadId: id,
    companyId: 999,

    createdAt: createdAt.toISOString(),
    updatedAt: createdAt.toISOString(),

    status,
    notifiedAt: null,
    viewedAt: status === 1 ? new Date(createdAt.getTime() + 15 * 60000).toISOString() : null,

    targetType,
    type,

    pricing: {
      servicePriceOf: null,
      servicePriceFor: null,
      perLeadPrice: (id % 5 + 1) * 15,
      discountPercentage: !isService ? (id % 30) : null,
      validFrom: null,
      validTo: null
    },

    customer: {
      id: 1000 + id,
      name: `Cliente ${id}`,
      document: `0000000000${id}`.slice(-11),
      email: `cliente${id}@email.com`,
      phone: `2199999000${id}`.slice(-11)
    },

    customerAddress: {
      id: 2000 + id,
      city: id % 2 === 0 ? 'Rio de Janeiro' : 'Niterói',
      state: 'RJ',
      zipcode: '20000-000',
      address: 'Rua Exemplo',
      number: String(10 + id),
      complement: null,
      neighborhood: 'Centro'
    },

    serviceOrDiscount: {
      type,
      SystemCfgId: 3000 + (id % 10),
      SystemRepoId: 4000 + (id % 10),
      name: isService ? `Consulta ${id % 10}` : `Cupom ${id % 10}`,
      key: isService ? `service_${id % 10}` : `discount_${id % 10}`
    },

    targetCustomer: {
      document: targetType === 'thirdparty' ? `1111111111${id}`.slice(-11) : null,
      email: targetType === 'thirdparty' ? `target${id}@email.com` : null,
      phone: targetType === 'thirdparty' ? `2198888000${id}`.slice(-11) : null,
      phoneType: targetType === 'thirdparty' ? 'whatsapp' : null
    }
  };
};

const fakeListLeads = (pagination) => {
  const total = 137;
  const first = Number(pagination?.first || 0);
  const rows = Number(pagination?.rows || 10);

  const data = [];
  for (let i = first + 1; i <= Math.min(first + rows, total); i++) {
    data.push(buildFakeLead(i));
  }

  return { count: total, data };
};

const normalizeRetrieveLeadsPayload = (raw = {}) => {
  // pagination obrigatório no endpoint
  const pagination = raw?.pagination && typeof raw.pagination === 'object'
    ? raw.pagination
    : {
        sortField: raw?.sortField || 'createdAt',
        sortOrder: typeof raw?.sortOrder !== 'undefined' ? raw.sortOrder : -1,
        rows: Number.isInteger(raw?.rows) ? raw.rows : 10,
        first: Number.isInteger(raw?.first) ? raw.first : 0,
      };

  // filters obrigatório no endpoint
  // endpoint aceita "sem filtro" quando mode null e fields {}
  let filters = raw?.filters;

  const isValidFiltersObject =
    filters && typeof filters === 'object' && !Array.isArray(filters);

  if (!isValidFiltersObject) {
    filters = { mode: null, field: null, term: '', fields: {} };
  } else {
    // Se vier vazio {} do componente, transforma em default esperado
    const hasAnyKey = Object.keys(filters).length > 0;

    if (!hasAnyKey) {
      filters = { mode: null, field: null, term: '', fields: {} };
    } else {
      // Normalizações defensivas para evitar 400
      if (!('mode' in filters)) filters.mode = null;
      if (!('field' in filters)) filters.field = null;
      if (!('term' in filters)) filters.term = '';
      if (!('fields' in filters)) filters.fields = {};

      // Se for advanced e o componente mandou no shape errado, tenta acomodar
      // (seu código já manda { fields: {...}, mode:"advanced" }, então aqui só garante)
      if (filters.mode === 'advanced') {
        const fieldsObj = filters.fields && typeof filters.fields === 'object' && !Array.isArray(filters.fields)
          ? filters.fields
          : {};
        filters.fields = fieldsObj;
      }

      // Se for basic: endpoint espera field como OBJETO com .field (igual ao seu state "filter")
      // e term string preenchida
      if (filters.mode === 'basic') {
        if (!filters.field || typeof filters.field !== 'object') {
          // fallback: se veio string, transforma no shape que o backend aceita
          if (typeof filters.field === 'string') {
            filters.field = { field: filters.field };
          } else {
            filters.field = { field: 'customerName' };
          }
        }
        if (typeof filters.term !== 'string') {
          filters.term = String(filters.term || '');
        }
      }
    }
  }

  return {
    status: raw?.status ?? null,
    pagination,
    filters,
  };
};


// -----------------------------
// retrieveLeads (list)
// -----------------------------
export const retrieveLeads = (data, props = {}) => {
  return (dispatch) => {
    if (props.setLoading) props.setLoading(true);

    // Converte payload flat do componente -> payload esperado pelo endpoint
    const payload = normalizeRetrieveLeadsPayload(data);

    // FAKE MODE
    if (USE_FAKE_LEADS) {
      setTimeout(() => {
        const result = fakeListLeads(payload.pagination);

        if (props.setRows) props.setRows(result.data);
        if (props.setTotalRecords) props.setTotalRecords(result.count);
        if (props.setLoading) props.setLoading(false);

        dispatch({ type: 'SET_LEADS_LIST', payload: result.data });
      }, 500);
      return;
    }

    // REAL MODE
    axios({
      url: `${config.API_URL}/api/v1/company/retrieveLeads`,
      method: 'POST',
      data: payload, // <<<<<< aqui vai o payload normalizado
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData'),
      }
    })
      .then((response) => {
        const result = response.data;

        if (result?.success) {
          if (props.setRows) props.setRows(result.data || []);
          if (props.setTotalRecords) props.setTotalRecords(Number(result.count || 0));
          dispatch({ type: 'SET_LEADS_LIST', payload: result.data || [] });
        } else {
          if (props.setRows) props.setRows([]);
          if (props.setTotalRecords) props.setTotalRecords(0);
          if (props.setAlert) props.setAlert(true);
          if (props.setAlertTitle) props.setAlertTitle('Atenção');
          if (props.setAlertBody) props.setAlertBody(result?.message || 'Erro ao carregar direcionamentos.');
        }

        if (props.setLoading) props.setLoading(false);
      })
      .catch((error) => {
        console.error('Erro ao recuperar leads:', error);

        // Se a API devolveu body com detalhes (400), isso ajuda muito no debug
        const apiMsg =
          error?.response?.data?.errorsDetail?.join(' | ') ||
          error?.response?.data?.errorMessage ||
          null;

        if (props.setRows) props.setRows([]);
        if (props.setTotalRecords) props.setTotalRecords(0);
        if (props.setLoading) props.setLoading(false);

        if (props.setAlert) props.setAlert(true);
        if (props.setAlertTitle) props.setAlertTitle('Erro');
        if (props.setAlertBody) props.setAlertBody(apiMsg || 'Erro inesperado. Verifique sua conexão.');
      });
  };
};


// -----------------------------
// retrieveLead (single)
// -----------------------------
export const retrieveLead = (data, props = {}) => {
  return (dispatch) => {
    if (props.setLoadingData) props.setLoadingData(true);

    const safeLeadId = Number(data?.leadId);

    // FAKE MODE
    if (USE_FAKE_LEADS) {
      setTimeout(() => {
        const lead = buildFakeLead(safeLeadId || 1);

        // acrescenta extras no detalhe fake (para testar UI)
        lead.comments = [
          {
            id: 1,
            title: 'Contato iniciado',
            comment: 'Cliente demonstrou interesse e pediu informações adicionais.',
            createdAt: new Date().toISOString()
          }
        ];
        lead.statusHistory = [
          { id: 1, status: 0, createdAt: lead.createdAt },
          { id: 2, status: 1, createdAt: new Date().toISOString() }
        ];

        dispatch({ type: 'SET_CURRENT_LEAD', payload: lead });

        if (props.setSuccess) props.setSuccess(lead);
        if (props.setLoadingData) props.setLoadingData(false);
      }, 450);
      return;
    }

    // REAL MODE
    axios({
      url: `${config.API_URL}/api/v1/company/retrieveLead`,
      method: 'POST',
      data,
      headers: {
        Accept: 'application/json',
        'x-access-token': localStorage.getItem('@estacaodoolho/userData')
      }
    })
      .then((response) => {
        const result = response.data;

        if (result?.success && result?.found) {
          dispatch({ type: 'SET_CURRENT_LEAD', payload: result.data });
          if (props.setSuccess) props.setSuccess(result.data);
        } else {
          if (props.setError) props.setError(result?.message || 'Lead não encontrado.');
        }

        if (props.setLoadingData) props.setLoadingData(false);
      })
      .catch((error) => {
        console.error('Erro ao recuperar lead:', error);

        if (props.setLoadingData) props.setLoadingData(false);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão.');
      });
  };
};



/* -------------------------------------------------------------------- */
/*  COMPANY PROFILE - BLOCO 1 (Dados da empresa)                         */
/* -------------------------------------------------------------------- */

export const retrieveCompanyData = (props = {}) => {
  return (dispatch) => {

    const token = getUserToken();

    console.log('Token retrieveCompanyData:', token);

    axios({
      url: config.API_URL + '/api/v1/company/retrieveCompanyData',
      method: 'GET',
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao recuperar dados da empresa.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result.data);
      })
      .catch((error) => {
        console.error('[retrieveCompanyData] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};

export const updateCompanyData = (data = {}, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/updateCompanyData',
      method: 'PUT',
      data,
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao atualizar dados da empresa.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[updateCompanyData] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};


/* -------------------------------------------------------------------- */
/*  Company - Billing Data                                              */
/* -------------------------------------------------------------------- */

export const retrieveCompanyBillingData = (props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/retrieveCompanyBillingData',
      method: 'GET',
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao carregar dados de faturamento.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[retrieveCompanyBillingData] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};

export const updateCompanyBillingData = (data = {}, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/updateCompanyBillingData',
      method: 'PUT',
      data,
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao atualizar dados de faturamento.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[updateCompanyBillingData] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};

export const retrieveCompanyLogotype = (props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/retrieveCompanyLogotype',
      method: 'GET',
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response;

        if (!result) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao carregar logomarca.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result || null);
      })
      .catch((error) => {
        console.error('[retrieveCompanyLogotype] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};


export const updateCompanyLogotype = (file, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    const formData = new FormData();
    formData.append('companyLogotype', file);

    axios({
      url: config.API_URL + '/api/v1/company/updateCompanyLogotype',
      method: 'POST',
      data: formData,
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
        // NÃO setar Content-Type manualmente. O browser define boundary.
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao atualizar logomarca.');
          return;
        }

        // backend retorna { success:true, updated:true, data:{ fileName, url } }
        if (props.setSuccess) props.setSuccess(result?.data || null);
      })
      .catch((error) => {
        console.error('[updateCompanyLogotype] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};

export const retrieveCompanyBusinessData = (props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/retrieveCompanyBusinessData',
      method: 'GET',
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) {
            props.setError(result?.errorMessage || 'Erro ao recuperar dados do negócio.');
          }
          return;
        }

        // backend retorna { success:true, data:{...} }
        if (props.setSuccess) {
          props.setSuccess(result?.data || null);
        }
      })
      .catch((error) => {
        console.error('[retrieveCompanyBusinessData] error:', error);
        if (props.setError) {
          props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};

export const updateCompanyBusinessData = (data, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/updateCompanyBusinessData',
      method: 'PUT',
      data: data || {},
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) {
            props.setError(result?.errorMessage || 'Erro ao atualizar dados do negócio.');
          }
          return;
        }

        /**
         * Seu backend (no final do método) chama retrieveCompanyBusinessData(req,res),
         * então a resposta já deve vir no formato:
         * { success:true, data:{...} }
         */
        if (props.setSuccess) {
          props.setSuccess(result?.data || null);
        }
      })
      .catch((error) => {
        console.error('[updateCompanyBusinessData] error:', error);
        if (props.setError) {
          props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
        }
      });
  };
};


/* -------------------------------------------------------------------- */
/*  COMPANY PROFILE - BLOCO 5 (Endereço)                                */
/* -------------------------------------------------------------------- */

export const retrieveCompanyAddress = (props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/retrieveCompanyAddress',
      method: 'GET',
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao recuperar endereço da empresa.');
          return;
        }

        // backend retorna { success:true, found:boolean, data:null|object }
        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[retrieveCompanyAddress] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};

export const updateCompanyAddress = (data = {}, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/updateCompanyAddress',
      method: 'PUT',
      data: data || {},
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao atualizar endereço da empresa.');
          return;
        }

        // backend (no seu método atual) retorna confirmação.
        // Se você ajustar o backend para retornar o retrieve, aqui também funciona.
        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[updateCompanyAddress] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};


/* -------------------------------------------------------------------- */
/*  COMPANY PROFILE - BLOCO 6 (Links e mídias)                          */
/* -------------------------------------------------------------------- */

export const retrieveCompanyLinksAndMedia = (props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + "/api/v1/company/retrieveCompanyLinksAndMedia",
      method: "GET",
      headers: {
        "x-access-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || "Erro ao recuperar links e mídias.");
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error("[retrieveCompanyLinksAndMedia] error:", error);
        if (props.setError) props.setError("Erro inesperado. Verifique sua conexão ou tente novamente.");
      });
  };
};

export const updateCompanyLinksAndMedia = (data = {}, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + "/api/v1/company/updateCompanyLinksAndMedia",
      method: "PUT",
      data: data || {},
      headers: {
        "x-access-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || "Erro ao atualizar links e mídias.");
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error("[updateCompanyLinksAndMedia] error:", error);
        if (props.setError) props.setError("Erro inesperado. Verifique sua conexão ou tente novamente.");
      });
  };
};

/* -------------------------------------------------------------------- */
/*  Company - Services Leads (leadMaxQuantity)                           */
/* -------------------------------------------------------------------- */

export const retrieveCompanyServicesLeads = (props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/retrieveCompanyServicesLeads',
      method: 'GET',
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao carregar direcionamentos configurados.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[retrieveCompanyServicesLeads] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};

export const updateCompanyServicesLeads = (data = {}, props = {}) => {
  return (dispatch) => {
    const token = getUserToken();

    axios({
      url: config.API_URL + '/api/v1/company/updateCompanyServicesLeads',
      method: 'PUT',
      data,
      headers: {
        'x-access-token': token,
        Accept: 'application/json'
      }
    })
      .then((response) => {
        const result = response.data;

        if (!result?.success) {
          if (props.setError) props.setError(result?.errorMessage || 'Erro ao atualizar direcionamentos configurados.');
          return;
        }

        if (props.setSuccess) props.setSuccess(result);
      })
      .catch((error) => {
        console.error('[updateCompanyServicesLeads] error:', error);
        if (props.setError) props.setError('Erro inesperado. Verifique sua conexão ou tente novamente.');
      });
  };
};
